import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinnerContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_op_modal_container = _resolveComponent("op-modal-container")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "appContainer",
    onDragenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setHightlights && _ctx.setHightlights(...args))),
    onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setHightlights && _ctx.setHightlights(...args))),
    onDragend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unsetHighlights && _ctx.unsetHighlights(...args))),
    onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsetHighlights && _ctx.unsetHighlights(...args)))
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
          [_vShow, _ctx.showSpinner]
        ])
      ]),
      _: 1
    }),
    (_ctx.showApp)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_op_modal_container)
  ], 544))
}